// extracted by mini-css-extract-plugin
export default {"tagBlocks":"FormArtistTagsSelect_tagBlocks__T6ncq","tagBlock":"FormArtistTagsSelect_tagBlock__tn4tl","tagBlockTitle":"FormArtistTagsSelect_tagBlockTitle__bE6Bo"};